import React from 'react';
import {inject, observer} from 'mobx-react';
import {withTranslation} from 'react-i18next';
import {Button} from 'semantic-ui-react';

let UserIdentitiesTableButtons = (props) => {
    const {t, userStore, userIdentitiesUIStore} = props;

    if (!userIdentitiesUIStore.selectedIdentity) {
        return null;
    }

    return (
        <div>
            <Button
                disabled={userStore.isExternallyManged()}
                onClick={userIdentitiesUIStore.openEditIdentityModal}>
                {t('common:common.edit')}
            </Button>
            <Button
                disabled={userStore.isExternallyManged()}
                onClick={userIdentitiesUIStore.openDeleteConfirm}>
                {t('common:common.delete')}
            </Button>
        </div>
    );
};

export default inject(
    'userStore',
    'userIdentitiesUIStore'
)(withTranslation()(observer(UserIdentitiesTableButtons)));
